import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

const CdxToolTip = (props) => {

    const popover = (
        <Popover className={props.className ? "cdx-tooltip " + props.className : "cdx-tooltip "}>
            <div className="cdx-tooltip-wrapper">
                <div
                    className="cdx-tooltip-content"
                    dangerouslySetInnerHTML={{ __html: props.content }}
                />
            </div>
        </Popover>
    );

    return <OverlayTrigger trigger={props.trigger || ['hover', 'focus', 'click']} placement={props.placement || "bottom-end"} overlay={popover} rootClose>
        {props.children}
    </OverlayTrigger>;
};

export default CdxToolTip;